import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType, ChartTimerName } from '@frontend/chart/types';
import { Application } from '@frontend/functionality/types';

import { TRANSACTION_TIMERS_DURATION_BY_USER_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const PUDO_TRANSACTION_TIMERS_DURATION_BY_USER_PICK_UP_LIST_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.PUDO_TRANSACTION_TIMERS_DURATION_BY_USER_PICK_UP_LIST,
    chartType: ChartRendererType.LIST,
    endpoint: TRANSACTION_TIMERS_DURATION_BY_USER_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.PUDO },
        { key: ChartQueryParam.NAME, value: ChartTimerName.TRANSACTION_PICK_UP_PENDING },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }
    ]
};
